module.exports = __webpack_public_path__ + "img/whitetimer1.037d06c2.svg";